<template>
  <v-container class="promotion-container" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="mb-4">
          <v-card-title>
            <h2>{{ $t('userInvites.promotionTitle') }}</h2>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6" v-for="card in promotionCards" :key="card.alt">
                <v-card class="promotion-card">
                  <v-img :src="card.imgSrc" :alt="$t(card.alt)" class="mb-2"></v-img>
                  <v-card-text>
                    <p>{{ $t(card.text) }}</p>
                  </v-card-text>
                  <v-divider></v-divider>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="invite-method">
          <v-card-title>
            <h3>{{ $t('userInvites.inviteMethodTitle') }}</h3>
          </v-card-title>
          <v-card-text @click="copyInviteCode">
            <v-text-field
              v-model="inviteLink"
              ref="invite-link"
              :label="$t('userInvites.copyInviteLink')"
              readonly
              append-outer-icon="mdi-content-copy"
              @click:append-outer="copyInviteCode"
            ></v-text-field>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="invites"
          :loading="loading"
          :loading-text="$t('userInvites.loading')"
          :no-data-text="$t('userInvites.noData')"
          :mobile-breakpoint="0"
          :items-per-page="10"
          class="elevation-1"
        >
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn icon @click="copyDirectAddress(item)">
                <v-icon>mdi-content-copy</v-icon>
              </v-btn>
            </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { fetchUserInvites } from '@/api/apiService';

export default {
  name: 'UserInvites',
  data() {
    return {
      inviteLink: '',
      headers: [],
      invites: [],
      promotionCards: [
        {
          imgSrc: require('@/assets/images/user/ccccccckaoqiang_A_visually_appealing_illustration_featuring_a_g_ed70d265-21f2-4fed-b981-bf9a200fbecf_no_background.png'),
          alt: 'userInvites.promotionCard.recommendFriend',
          text: 'userInvites.promotionCard.recommendFriend'
        },
        {
          imgSrc: require('@/assets/images/user/image-removebg.png'),
          alt: 'userInvites.promotionCard.claimAirdrop',
          text: 'userInvites.promotionCard.claimAirdrop'
        }
      ]
    };
  },
  props: {
    walletConnect: {
      type: Object,
      required: true
    }
  },
  methods: {
    loadInvites() {
      fetchUserInvites().then(response => {
        this.inviteLink = response.data.data.invite_link;
      });
    },
    async loadDirect() {
      if(this.walletConnect.isConnected) {
        let list = await this.walletConnect.getDirectUser();
        if(list.length > 0) {
          let data = [];
          for (let i = 0; i < list.length; i++) {
            data.push({address: list[i]});
          }
          this.invites = data;
        }
      }
    },
    copyDirectAddress(item) {
       const address = item.address;
       navigator.clipboard.writeText(address).then(() => {
          this.$toast.success(this.$t('userInvites.copied'));
       }).catch((err) => {
          console.log('Something went wrong', err);
       });
    },
    copyInviteCode() {
      const inviteLinkInput = this.$refs['invite-link'];
      inviteLinkInput.select();
      document.execCommand('copy');
      this.$toast.success(this.$t('userInvites.inviteCodeCopied'));
    }
  },
  mounted() {
    let language = this.$i18n.locale;
    this.headers = [
      { title: this.$t('userInvites.address', { language }), key: 'address' },
      { title: this.$t('userEarnings.actions', { language }), value: 'actions', sortable: false },
    ];

    this.loadInvites();
    this.loadDirect();
  }
};
</script>

<style scoped>
.promotion-container {
  padding: 20px;
}

.promotion-card {
  margin-bottom: 20px;
}

.invite-method {
  margin-top: 20px;
}
</style>